import { Controller } from "@hotwired/stimulus"

// Handles variant product cards: Add to cart -> size selector -> In Cart rows
export default class extends Controller {
  static targets = ["inCartRow", "sizeSelector", "addAnotherButton", "addToCartButton", "productTotal"]

  connect() {
    this.showSizeSelector = false
    this.syncVisibility()
  }

  revealSizeSelector(event) {
    event.preventDefault()
    this.showSizeSelector = true
    this.syncVisibility()
  }

  addSize(event) {
    const button = event.currentTarget
    const variantId = button.dataset.variantId
    const row = this.inCartRowTargets.find(r => String(r.dataset.variantId) === String(variantId))
    const input = row?.querySelector("[data-upsell-target='quantityInput']")
    if (!input) return

    const val = parseInt(input.value, 10) || 0
    const maxRaw = input.getAttribute("max")
    const max = maxRaw !== null && maxRaw !== "" ? parseInt(maxRaw, 10) : null
    const nextVal = val + 1
    if (max !== null && !Number.isNaN(max) && nextVal > max) return
    input.value = nextVal
    input.dispatchEvent(new Event("change", { bubbles: true }))

    this.showSizeSelector = false
    this.syncVisibility()
  }

  syncVisibility() {
    let productTotal = 0

    this.inCartRowTargets.forEach(row => {
      const input = row.querySelector("[data-upsell-target='quantityInput']")
      const qty = parseInt(input?.value, 10) || 0
      const price = parseFloat(row.dataset.upsellPriceValue || 0)
      row.classList.toggle("hidden", qty <= 0)
      productTotal += price * qty
    })

    const hasAnyInCart = this.inCartRowTargets.some(row => {
      const input = row.querySelector("[data-upsell-target='quantityInput']")
      return (parseInt(input?.value, 10) || 0) > 0
    })

    if (this.hasAddToCartButtonTarget) {
      this.addToCartButtonTarget.classList.toggle("hidden", hasAnyInCart || this.showSizeSelector)
    }
    if (this.hasAddAnotherButtonTarget) {
      this.addAnotherButtonTarget.classList.toggle("hidden", !hasAnyInCart || this.showSizeSelector)
    }
    if (this.hasSizeSelectorTarget) {
      this.sizeSelectorTarget.classList.toggle("hidden", !this.showSizeSelector)
    }
    if (this.hasProductTotalTarget && productTotal > 0) {
      this.productTotalTarget.textContent = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(productTotal)
      this.productTotalTarget.classList.remove("hidden")
    } else if (this.hasProductTotalTarget) {
      this.productTotalTarget.classList.add("hidden")
    }
  }

  expandSizeSelector(event) {
    event.preventDefault()
    this.showSizeSelector = true
    this.syncVisibility()
  }

  closeSizeSelector(event) {
    event.preventDefault()
    this.showSizeSelector = false
    this.syncVisibility()
  }
}
